import React, { useState } from "react";
import { useApp } from "context";
import { Custom, Modal } from "components";
import { Box, Grid, Typography } from "@mui/material";
import { IBookedWaiting } from "interfaces/bookedwaiting";

type Props = {};

export const AppointmentStats = (props: Props) => {
  const { service, t, theme } = useApp();
  const [state, setState] = useState(false);
  const [opened, setOpened] = useState(false);
  const [data, setData] = useState<IBookedWaiting>({
    booked: 0,
    waiting: 0,
  } as IBookedWaiting);

  const handleAppointmentOpen = (state: boolean) => {
    setState(state);
    setOpened(true);
  };
  const handleAppointmentClose = () => {
    setOpened(false);
    fetchData();
  };

  async function fetchData() {
    const [status, response] = await service.appointment.today(true);
    setData(response);
  }

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Custom.Card
        title={t.title.appointment}
        action={
          <Custom.Button size="small" variant="outlined" onClick={fetchData}>
            {t.action.refresh}
          </Custom.Button>
        }
      >
        <Box sx={{ position: "relative" }}>
          <Grid container spacing={theme.margin.md}>
            <Grid item xs={6} md>
              <Box
                component="div"
                className="qh-item qh-service"
                sx={{
                  cursor: "default",
                  backgroundColor: theme.palette.background.color,
                }}
                onClick={() => handleAppointmentOpen(true)}
              >
                <div className="wrapper">
                  <Typography
                    component="span"
                    sx={{
                      fontSize: theme.font.lg,
                      color: theme.palette.font.accent,
                    }}
                  >
                    {t.label.booked}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      fontSize: theme.font.xxl,
                      color: theme.palette.font.color,
                    }}
                  >
                    {data.booked ?? 0}
                  </Typography>
                </div>
              </Box>
            </Grid>
            <Grid item xs={6} md>
              <Box
                component="div"
                className="qh-item qh-service"
                sx={{
                  backgroundColor: theme.palette.background.color,
                }}
                onClick={() => handleAppointmentOpen(false)}
              >
                <div className="wrapper">
                  <Typography
                    component="span"
                    sx={{
                      fontSize: theme.font.lg,
                      color: theme.palette.font.accent,
                    }}
                  >
                    {t.label.waiting}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      fontSize: theme.font.xxl,
                      color: theme.palette.font.color,
                    }}
                  >
                    {data.waiting ?? 0}
                  </Typography>
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Custom.Card>
      <Modal.Appointment
        state={state}
        opened={opened}
        onClose={handleAppointmentClose}
      />
    </>
  );
};
